document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector("#header-component");
  if (!header) return;

  const threshold = 50;

  function styleHeader() {
    // Tekst hvit
    header.querySelectorAll("a, button, .link").forEach(el => {
      el.style.setProperty("color", "#fff", "important");
    });

    // Alle ikoner: hvit kontur, ingen fyll
    header.querySelectorAll("svg").forEach(icon => {
      icon.style.setProperty("fill", "none", "important");
      icon.style.setProperty("stroke", "#fff", "important");
    });
  }

  function setTransparent() {
    header.classList.remove("scrolled");
    header.style.setProperty("background", "transparent", "important");
    header.style.setProperty("box-shadow", "none", "important");
    styleHeader();
  }

  function setSolid() {
    header.classList.add("scrolled");
    header.style.setProperty("background", "#1C2A52", "important");
    header.style.setProperty("box-shadow", "0 2px 12px rgba(0,0,0,.08)", "important");
    styleHeader();
  }

  function onScroll() {
    if (window.scrollY > threshold) setSolid();
    else setTransparent();
  }

  onScroll();
  window.addEventListener("scroll", onScroll, { passive: true });
});
document.addEventListener('DOMContentLoaded', function () {
  // Finn header (ikke announcement bar)
  const header =
    document.querySelector('#shopify-section-header-group header') ||
    document.querySelector('#shopify-section-header-group .header') ||
    document.querySelector('header');

  if (!header) return;

  // Finn venstre kolonne i header hvis den finnes
  const leftCol =
    header.querySelector('.header__column--left') ||
    header.querySelector('.header_column--left') ||
    header.querySelector('[class*="header"][class*="column"][class*="left"]');

  // Finn en eksisterende desktop-nav (for å hente lenker og plassere knapp foran)
  const desktopNav =
    header.querySelector('nav, .header__nav, .site-navigation, .menu--desktop');

  // 1) Lag burger-knappen
  let btn = header.querySelector('.lp2-toggle');
  if (!btn) {
    btn = document.createElement('button');
    btn.className = 'lp2-toggle';
    btn.setAttribute('aria-controls', 'lp2-menu');
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-label', 'Open menu');
    btn.innerHTML = `
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M3 6h18M3 12h18M3 18h18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>`;
  }

  // Plasser knappen: foretrekk venstre kolonne, ellers rett foran nav, ellers først i header
  if (leftCol) leftCol.prepend(btn);
  else if (desktopNav && desktopNav.parentNode) desktopNav.parentNode.insertBefore(btn, desktopNav);
  else header.prepend(btn);

  // Hvis knappen havner i announcement bar ved en feil, flytt den til header
  const ann = document.querySelector('#shopify-section-announcement-bar, #shopify-section-announcement, .announcement-bar');
  if (ann && ann.contains(btn)) header.prepend(btn);

  // 2) Lag sidepanel + backdrop
  let panel = document.querySelector('.lp2-menu');
  if (!panel) {
    panel = document.createElement('div');
    panel.className = 'lp2-menu';
    panel.id = 'lp2-menu';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    panel.setAttribute('aria-label', 'Site menu');
    panel.innerHTML = `
      <button class="lp2-close" aria-label="Close menu">
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        </svg>
      </button>
      <nav class="lp2-nav"><ul class="lp2-list"></ul></nav>
    `;
    document.body.appendChild(panel);
  }

  let backdrop = document.querySelector('.lp2-backdrop');
  if (!backdrop) {
    backdrop = document.createElement('div');
    backdrop.className = 'lp2-backdrop';
    document.body.appendChild(backdrop);
  }

  // 3) Fyll panel med lenker fra desktop-nav (enkelt nivå)
  const list = panel.querySelector('.lp2-list');
  if (list) {
    list.innerHTML = '';
    if (desktopNav) {
      desktopNav.querySelectorAll('a[href]').forEach(a => {
        const href = a.getAttribute('href');
        const text = (a.textContent || '').trim();
        if (!href || !text) return;
        if (list.querySelector(`a[href="${href}"]`)) return; // unngå duplikat
        const li = document.createElement('li');
        li.className = 'lp2-item';
        li.innerHTML = `<a href="${href}">${text}</a>`;
        list.appendChild(li);
      });
    }
  }

  // 4) Åpne/lukke
  const closeBtn = panel.querySelector('.lp2-close');

  function openMenu(){
    panel.classList.add('open');
    backdrop.classList.add('show');
    document.body.classList.add('lp2-no-scroll');
    btn.setAttribute('aria-expanded','true');
  }
  function closeMenu(){
    panel.classList.remove('open');
    backdrop.classList.remove('show');
    document.body.classList.remove('lp2-no-scroll');
    btn.setAttribute('aria-expanded','false');
  }
  function toggleMenu(){ panel.classList.contains('open') ? closeMenu() : openMenu(); }

  btn.addEventListener('click', toggleMenu);
  closeBtn && closeBtn.addEventListener('click', closeMenu);
  backdrop.addEventListener('click', closeMenu);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeMenu(); });

  // 5) Når alt er klart: skjul desktop-nav på brede skjermer
  document.body.classList.add('lp2-hide-desktop-nav');
});
